var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "root", staticClass: "checkout-delivery" },
    [
      _c(
        "ui-notification",
        {
          staticClass: "delivery-notification",
          attrs: {
            title: "Не выбран способ получения для " + _vm.productsCount,
            color: "#FFB71B"
          }
        },
        [
          _c("span", [_vm._v("\n      " + _vm._s(_vm.subtitle) + "\n    ")]),
          _c("template", { slot: "action" }, [
            _c(
              "div",
              { staticClass: "delivery-buttons" },
              _vm._l(_vm.buttons, function(button) {
                return _c("ui-button", {
                  key: button.value,
                  class: ["delivery-button", { hidden: button.hidden }],
                  attrs: { text: button.title },
                  on: {
                    click: function($event) {
                      return _vm.cardSelect(button.value)
                    }
                  }
                })
              }),
              1
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }